<template>
  <div>
    <div class="header">
      <home-top></home-top>
    </div>
    <div class="main">
      <div class="mainChild">
        <img src="../assets/culture1.png" class="p-imgStyle" />
      </div>
      <div class="mainContent">
        <div class="mainContentChild">
          <div class="mainContentChildTop">
            <div>
              <el-button class="btnContentUs">联系我们</el-button>
            </div>
            <!-- <div class="p-marginLeft50">
                            <el-button class="btnContentUs1">在线留言</el-button>
                        </div> -->
          </div>
          <div class="mainContentChildFooter">
            <!-- 详细地址显示 -->
            <div class="mainContentFooterChild">
              <div class="mainContentFooterChildFont">
                <span>山哩数智科技有限公司</span>
              </div>
              <div v-for="(item, index) in addressArray" :key="index" class="loopFrame">
                <div class="loopFrameChildImg">
                  <img :src="item.url" class="p-imgStyle" />
                </div>
                <div class="p-marginLeft10">
                  <span>{{ item.title }}</span>
                </div>
                <div class="p-marginLeft10">
                  <span>{{ item.telephone }}</span>
                </div>
              </div>
            </div>
            <!-- 高德地图组件 -->
            <div class="mainContentFooterChild1">
              <amap></amap>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="elFooter">
      <home-bottom></home-bottom>
    </div>
  </div>
</template>

<script>
import swiper from "../assembly/swiper.vue"
import homeTop from '../assembly/homeTop.vue'
import homeBottom from '../assembly/homeBottom.vue'
import amap from '../assembly/amap.vue'
export default {
  data() {
    return {
      swiperSetting: {
        delay: 3000
      },
      rotationFont: "公司公告: 山哩优品品牌发起, 累计销售额突破20亿元, 细分赛道国内前三名",
      addressArray: [
        { url: require("@/assets/iphones.png"), title: "电话:", telephone: "4006665230" },
        { url: require("@/assets/email.png"), title: "邮箱:", telephone: "ShanLiCPB@163.com" },
        { url: require("@/assets/address.png"), title: "地址:", telephone: "贵州省贵阳市南明区财富广场6号" }
      ],
    }
  },
  components: {
    homeTop,
    swiper,
    homeBottom,
    amap
  }
}
</script>

<style scoped lang="scss">
.header {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 4.5rem;
}

.main {
  position: absolute;
  height: 80%;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.mainChild {
  width: 100%;
}

.mainContent {
  display: flex;
  justify-content: center;

  .mainContentChild {
    background-color: #fff;
    position: relative;
    top: -25vh;
    height: 60vh;
    width: 55%;
    border-radius: 5px;
    box-shadow: 4px 2px 8px 1px #BBBBBB;
    display: flex;
    flex-direction: column;

    .mainContentChildTop {
      height: 15%;
      display: flex;
      justify-content: center;
      align-items: center;
      border-bottom: solid 2px #7B0000;

      .btnContentUs {
        color: #fff;
        background-color: #7B0000;
        width: 10.5rem;
      }

      .btnContentUs1 {
        border: #7B0000 solid 1px;
        color: #7B0000;
        width: 10.5rem;
      }
    }

    .mainContentChildFooter {
      margin: 2rem;
      height: 80%;
      display: flex;
      justify-content: center;
      align-items: center;

      .mainContentFooterChild {
        height: 20vh;
        width: 30%;
        border-radius: 4px;
        box-shadow: 4px 2px 8px 1px #BBBBBB;

        .mainContentFooterChildFont {
          padding: 1rem;
          font-size: 14px;
          display: flex;
          justify-content: center;
          align-items: center;
          background-color: #7B0000;
          color: #fff;
        }

        .loopFrame {
          padding: 1rem 0;
          display: flex;
          width: 100%;
          overflow: hidden;
          align-items: center;
          font-size: 0.8rem;
          border-top: solid 1px #BBBBBB;

          .loopFrameChildImg {
            margin-left: 1rem;
            width: 1.3rem;
          }
        }
      }

      .mainContentFooterChild1 {
        margin-left: 60px;
        height: 35vh;
        width: 55%;
        border-radius: 10px;
        box-shadow: 4px 2px 8px 1px #BBBBBB;
      }
    }
  }
}

// 底部
.elFooter {
  position: absolute;
  top: 91.5%;
  width: 100%;
  height: 300px;
}
</style>



// WEBPACK FOOTER //
// src/components/contactWe.vue